(ns app.domain.fee.rule-check
  (:require [app.domain.fee.formula :as formula]))


(defn price-ok-for-unit?
  "Check that unit price formula in a fee item adheres to the rules in order to show a unit in that same item's
  quantity formula, used in both front and back. For that the unit price formula must only consist of 0-1 variables
  and if there is a variable, that variable must not have a unit itself."
  [price-formula price-unit]
  (when price-formula
    (and (nil? price-unit)
         (or (= price-formula (formula/first-variable price-formula))
             (nil? (formula/first-variable price-formula))))))
